/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UsuarioEnviarMultiplesCorreosGet$Params {
  Accept?: string;
  'idUsers[]'?: string;
  'emails[]'?: string;
}

export function usuarioEnviarMultiplesCorreosGet(http: HttpClient, rootUrl: string, params?: UsuarioEnviarMultiplesCorreosGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, usuarioEnviarMultiplesCorreosGet.PATH, 'get');
  if (params) {
    rb.header('Accept', params.Accept, {});
    rb.query('idUsers[]', params['idUsers[]'], {});
    rb.query('emails[]', params['emails[]'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

usuarioEnviarMultiplesCorreosGet.PATH = '/usuario/enviar-multiples-correos';
